module.exports = __webpack_public_path__ + "screen3.webp?981ddd916380e3548e5fb32c6b61cf42";